import { OlympiadsApi } from 'api';
import useUserData from 'hooks/useUserData';
import { useEffect, useState } from 'react';

export interface IResultOlymp {
  olympId: string;
  participantsCount: string;
  participantsPercent: string;
  prizeholdersCount: string;
	transitingPrizeholdersCount: string;
}

export const useRating = (dataParams: string[]) => {
  const [pendingResultOlymps, setPendingResultOlymps] = useState(false);
  const [resultOlymps, setResultOlymps] = useState<IResultOlymp[]>([]);
  useEffect(() => {
    const fetchRating = async () => {
      try {
        setPendingResultOlymps(true);
        const result = await OlympiadsApi.getResultOlympiads(dataParams);
        
        const data = result.map((el, i) => ({
          olympId: el.olymp_id,
          participantsCount: el.participants_count,
          participantsPercent: el.participants_percent,
          prizeholdersCount: el.prizeholders_count,
	        transitingPrizeholdersCount: el.transiting_prizeholders_count
        }));
        
        setResultOlymps(data);
      } catch (e) {
        console.log(e);
      } finally {
        setPendingResultOlymps(false);
      }
    };
    fetchRating();
  }, []);

  return {
    resultOlymps,
    pendingResultOlymps,
  };
};

export type useRating = ReturnType<typeof useRating>;
